"use client";

import React, { useState, useEffect } from "react";
import DashboardHeaderCard from "@/components/common/DashboardHeaderCard";
import { MapPin, CheckCircle, XCircle, Clock } from "lucide-react";
import portService from '@/services/portService';

const PortsManagementHeader = ({ ports }) => {
  const [stats, setStats] = useState({
    totalPorts: 0,
    activePorts: 0,
    inactivePorts: 0,
    recentPorts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortStats = async () => {
      try {
        setLoading(true);

        const allPortsData = await portService.getAllPorts();
        
        let allPorts = [];
        if (allPortsData && typeof allPortsData === 'object' && Array.isArray(allPortsData.data)) {
          allPorts = allPortsData.data;
        } else if (Array.isArray(allPortsData)) {
          allPorts = allPortsData;
        } else if (allPortsData && typeof allPortsData === 'object' && Array.isArray(allPortsData.ports)) {
          allPorts = allPortsData.ports;
        }
        
        const totalPorts = allPorts.length;
        const activePorts = allPorts.filter(port => port.is_active).length;
        const inactivePorts = totalPorts - activePorts;
        const recentPorts = allPorts.filter(port => {
          if (!port.created_at) return false;
          const createdDate = new Date(port.created_at);
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
          return createdDate >= sevenDaysAgo;
        }).length;
        
        setStats({
          totalPorts,
          activePorts,
          inactivePorts,
          recentPorts
        });
      } catch (error) {
        console.error("Failed to fetch port statistics:", error);
    
        const totalPorts = ports.length;
        const activePorts = ports.filter(port => port.status === 'Active').length;
        const inactivePorts = ports.filter(port => port.status === 'Inactive').length;
        const recentPorts = ports.filter(port => {
          if (!port.createdAt) return false;
          const createdDate = new Date(port.createdAt);
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
          return createdDate >= sevenDaysAgo;
        }).length;
        
        setStats({
          totalPorts,
          activePorts,
          inactivePorts,
          recentPorts
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPortStats();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full">
        <DashboardHeaderCard
          name="TOTAL PORTS"
          count="0"
          icon={<MapPin size={18} color="hsl(var(--primary))" />}
          differenceText="All Indian ports"
        />

        <DashboardHeaderCard
          name="ACTIVE PORTS"
          count="0"
          icon={<CheckCircle size={18} color="hsl(var(--primary))" />}
          differenceText="Operational"
        />

        <DashboardHeaderCard
          name="INACTIVE PORTS"
          count="0"
          icon={<XCircle size={18} color="hsl(var(--primary))" />}
          differenceText="Temporarily closed"
        />

        <DashboardHeaderCard
          name="RECENT PORTS"
          count="0"
          icon={<Clock size={18} color="hsl(var(--primary))" />}
          differenceText="Recently added"
        />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full">
      <DashboardHeaderCard
        name="TOTAL PORTS"
        count={stats.totalPorts.toString()}
        icon={<MapPin size={18} color="hsl(var(--primary))" />}
        differenceText="All Indian ports"
      />

      <DashboardHeaderCard
        name="ACTIVE PORTS"
        count={stats.activePorts.toString()}
        icon={<CheckCircle size={18} color="hsl(var(--primary))" />}
        differenceText="Operational"
      />

      <DashboardHeaderCard
        name="INACTIVE PORTS"
        count={stats.inactivePorts.toString()}
        icon={<XCircle size={18} color="hsl(var(--primary))" />}
        differenceText="Temporarily closed"
      />

      <DashboardHeaderCard
        name="RECENT PORTS"
        count={stats.recentPorts.toString()}
        icon={<Clock size={18} color="hsl(var(--primary))" />}
        differenceText="Recently added"
      />
    </div>
  );
};

export default PortsManagementHeader;